import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ModalOptions} from '@ionic/core';
import {DatePickerComponent} from '../../../hedging/components/date-picker/date-picker.component';
import {Moment} from 'moment';
import {ModalController, IonicModule} from '@ionic/angular';
import {isDefined, isNullOrUndefined} from '../../../../commons/utils';
import {DateFormatPipe} from '../../../../pipes/date-format/date-format.pipe';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-date-input',
  imports: [IonicModule, DateFormatPipe, TranslateModule],
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.css']
})
export class DateInputComponent implements OnInit, OnChanges {
  readonly isDefined = isDefined;
  readonly isNullOrUndefined = isNullOrUndefined;

  @Input() date: Moment;
  @Input() placeholder: string;
  @Input() minDate: Moment;
  @Input() maxDate: Moment;
  @Output() readonly changeDate = new EventEmitter<Moment>();

  dateDisplayValue: Date;
  isModalVisible = false;

  private modalObject: HTMLIonModalElement;

  constructor(private readonly modalController: ModalController) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isDefined(changes.date.currentValue)) {
      this.dateDisplayValue = changes.date.currentValue.toDate();
    }
  }

  ngOnInit(): void {
    if (isDefined(this.date)) {
      this.dateDisplayValue = this.date.toDate();
    }
  }

  async openDatePickerModal(): Promise<void> {
    const datePickerModalOptions: ModalOptions = {
      component: DatePickerComponent,
      componentProps: {
        minDate: this.minDate,
        maxDate: this.maxDate
      }
    };
    if (!this.isModalVisible) {
      this.isModalVisible = true;
      this.modalObject = await this.modalController.create(datePickerModalOptions);
      this.getModalData();
      await this.modalObject.present();
    }
  }

  private getModalData(): void {
    this.modalObject.onDidDismiss().then(modalData => {
      if (isDefined(modalData.data)) {
        this.date = modalData.data.dueDate;
      }
      this.isModalVisible = false;
      if (isDefined(this.date)) {
        this.dateDisplayValue = this.date.toDate();
        this.changeDate.emit(this.date);
      }
    });
  }
}
